import { computed } from 'mobx';
import $labels from 'app/stores/label/$labels';
import $notifications from 'app/stores/notifications/$notifications';
import { getPolicyManageUrl } from 'app/stores/alerting/policyUtils';
import { POLICY_APPLICATION_LABELS } from '@kentik/ui-shared/alerting/constants';
import Model from 'core/model/Model';

export default class BasePolicyModel extends Model {
  get urlRoot() {
    return '/api/ui/alerting/policies';
  }

  get sortValues() {
    return {
      name: () => this.name.trim().toLowerCase()
    };
  }

  // Used as an alias for server-side filtering purposes
  get policyID() {
    return this.id;
  }

  get name() {
    return this.get('name');
  }

  get description() {
    return this.get('description');
  }

  get ruleId() {
    throw new Error('BasePolicyModel: ruleId is not implemented.');
  }

  get lastModified() {
    throw new Error('BasePolicyModel: lastModified is not implemented.');
  }

  get application() {
    return this.get('application');
  }

  get dimensions() {
    return [];
  }

  get metrics() {
    return [];
  }

  get userId() {
    return this.get('user_id');
  }

  @computed
  get manageUrl() {
    return getPolicyManageUrl(this.application, !this.isNew && this.id, this.isUpDownPolicy);
  }

  @computed
  get cloneUrl() {
    return getPolicyManageUrl(this.application, false, this.isUpDownPolicy);
  }

  // Policy type values & checks

  @computed
  get applicationLabel() {
    return POLICY_APPLICATION_LABELS[this.application];
  }

  @computed
  get labels() {
    return this.id ? $labels.getLabels('policy', this.id) : [];
  }

  // Model actions

  fetch(...args) {
    // fetch notification channels first to prevent a race condition where the notification channels
    // are not available during deserialization of the policy collection
    return $notifications.collection.fetch().then(() => super.fetch(...args));
  }

  // Model serialization

  get omitDuringSerialize() {
    return ['uiProperties'];
  }

  serialize(...args) {
    return super.serialize(...args);
  }

  save(...args) {
    return super.save(...args);
  }
}
